export default __webpack_public_path__ + "static/OBJECTIVITY-d83a30a0512f7a60122eaa669d6b9f63.png";